import React from "react";
import { Box, Card, CardContent, Typography, Button, Alert } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useAuth } from "../context/AuthContext";

export default function Unauthorized() {
  const { user, authzError, logout } = useAuth();

  return (
    <Box sx={{ maxWidth: 480, mx: "auto", mt: 8 }}>
      <Card elevation={3} sx={{ borderRadius: 2 }}>
        <Box sx={{ bgcolor: "error.main", color: "white", p: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <BlockIcon />
          <Typography variant="h5">Access Denied</Typography>
        </Box>
        <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <Typography variant="body1">
            Your account <strong>{user?.username}</strong> is not authorized to access this application.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please contact your administrator to request access.
          </Typography>
          {authzError && <Alert severity="warning">{authzError}</Alert>}
          <Button variant="contained" color="primary" onClick={logout}>
            Sign Out
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
